// extracted by mini-css-extract-plugin
export default {"LoginSignupHeader":"login_LoginSignupHeader__3PkVe","loginForm":"login_loginForm__8pLv9","field":"login_field__q1hrv"};